"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getUserData = require("./getUserData");
Object.keys(_getUserData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getUserData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUserData[key];
    }
  });
});